import * as actionType from './actionTypes';

export function setPackSites(packSites:[]) {
  return {
    type: actionType.SET_PACKSITES,
    payload: packSites,
  }
}

export function appendPackSites(packSites:[]) {
  return {
    type: actionType.APPEND_PACKSITES,
    payload: packSites,
  }
}

export function setNoMorePackSite(noMorePacksites: boolean) {
  return {
    type: actionType.SET_NO_MORE_PACKSITE,
    payload: noMorePacksites,
  }
}

export function setPackDetailFilters(packDetailFilters:{}) {
  return {
    type: actionType.SET_PACKSITE_FILTERS,
    payload: packDetailFilters,
  }
}

export function setPackSiteState(state:string) {
  return {
    type: actionType.SET_PACKSITE_STATE,
    payload: state,
  }
}